module.exports = __webpack_public_path__ + "static/media/logo_dark.f65a804d.svg";